import PageComponent from "../../../components/Page/PageComponent"
import { VendorFeedback } from "../vendorFeedback/VendorFeedback"
import { VendorManagementTabs } from "./VendorManagementTabs"

export const VendorManagementPage = ({ }) => {
    return (
        <PageComponent>
            <VendorManagementTabs />
        </PageComponent >
    )
}